import React from 'react';
import { Link } from 'react-router';
import { Button } from 'shared/lib/SureDesignSystem';
import Footer from '../Footer/Footer';
import Review from '../Review/Review';
import Hero from './Hero';
import BuiltForEnterprise from './BuiltForEnterprise/BuiltForEnterprise';

import styles from './LandingConnect.module.css';

function LandingConnect() {
  return (
    <div className={styles.wrapper}>
      <Hero />

      <div className={styles.perksSection}>
        <div className={styles.perksSection_container}>
          <h2 className={styles.perksSection_perksTitle}>
            Native Insurance Integrations
          </h2>

          <p className={styles.perksSection_perksDescription}>
            SURE Connect quickly integrates the insurance program of your choice
            at the point of purchase.
          </p>

          <div className={styles.perksSection_perksItems}>
            <div className={styles.perksSection_perkItem}>
              <h3 className={styles.perksSection_perkTitle}>APIs</h3>
              <p className={styles.perksSection_perkDescription}>
                Integrate with modern RESTful APIs to unlock a fully native
                customer experience.
              </p>
            </div>
            <div className={styles.perksSection_perkItem}>
              <h3 className={styles.perksSection_perkTitle}>White Label</h3>
              <p className={styles.perksSection_perkDescription}>
                White label themes that deliver an experience customized for
                your brand.
              </p>
            </div>
            <div className={styles.perksSection_perkItem}>
              <h3 className={styles.perksSection_perkTitle}>iFrame</h3>
              <p className={styles.perksSection_perkDescription}>
                A single line of code to embed a seamless customer experience.
              </p>
            </div>
            <div className={styles.perksSection_perkItem}>
              <h3 className={styles.perksSection_perkTitle}>SDKs</h3>
              <p className={styles.perksSection_perkDescription}>
                iOS, Android, and Javascript SDKs for powerful native
                integrations.
              </p>
            </div>
          </div>
        </div>
      </div>

      <BuiltForEnterprise />

      <Review
        className={styles.review}
        review={{
          content:
            'Users were asking for an easy way to track and buy renters insurance and Sure is a leading insurance technology provider in this arena. A partnership with them made good sense for our clients.',
          author: 'Nathan Miller',
          position: 'President & Founder',
          logo: require('./assets/reviews/logo-rentec-direct.png'),
        }}
      />

      <div className={styles.leadGenSection}>
        <div className={styles.leadGenSection_container}>
          <h2 className={styles.leadGenSection_title}>
            Get started with SURE Connect.
          </h2>
          <Link to="/contact">
            <Button className={styles.leadGenSection_button}>
              CONTACT PARTNERSHIPS
            </Button>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default LandingConnect;
